import React, { useState } from 'react'
import { ReactComponent as TopTear } from '../../../assets/svgs/top-tear.svg'
import { ReactComponent as BottomTear } from '../../../assets/svgs/bottom-tear.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from '../../utils/modal'

const VideoBand = ({ content, videoIndex }) => {
    const [showModal, setShowModal] = useState(false)
    const [videoSource, setVideoSource] = useState(null)

    if (!content) {
        return null
    }

    const handleVideoClick = (video) => {
        if (video && video.url) {
            let videoSrc = video.url
            let ytSrc = videoSrc
            // Need to translate the YT string a bit
            if (videoSrc.indexOf('youtube') > -1) {
                let ytId = new RegExp('[\\?&]v=([^&#]*)').exec(videoSrc)
                if (ytId && ytId[1]) {
                    ytSrc = `//youtube.com/embed/${ytId[1]}?&autoplay=1&mute=0&rel=0&wmode=transparent&allowfullscreen`
                }
            } else if (videoSrc.indexOf('youtu.be') > -1) {
                let yId = videoSrc.substr(videoSrc.lastIndexOf('/') + 1)
                if (yId) {
                    ytSrc = `//youtube.com/embed/${yId}?&autoplay=1&mute=0&rel=0&wmode=transparent&allowfullscreen`
                }
            }
            setVideoSource(ytSrc)
            setShowModal(true)
        }
    }

    const renderVideoThumbs = () => {
        const totalItems = content.videos.length
        return content.videos.map((video, idx) => {
            let degree = 0
            if (totalItems === 1) {
                degree = -5
            } else if (totalItems === 2) {
                degree = idx === 0 ? -4 : 2
            } else if (totalItems === 3) {
                if (idx === 0) {
                    degree = -6
                } else if (idx === 1) {
                    degree = 3
                } else {
                    degree = -6
                }
            }
            return (
                <div key={idx} className="video-tile">
                    <div className="video-details">
                        <div className="video-title">{video.title}</div>
                        <button data-id={video.title} className="video-runtime" onClick={() => {
                            handleVideoClick(video)
                        }}>
                            <FontAwesomeIcon icon="play" />
                            {video.runtime}
                        </button>
                    </div>
                    <div data-id={video.title} className="video-thumbnail" style={{ transform: `rotate(${-1 * degree}deg)` }} onClick={() => {
                        handleVideoClick(video)
                    }}>
                        <img src={video.thumbnail.url} alt={video.thumbnail.alt} />
                    </div>
                </div>
            )
        })
    }

    const renderOptionalHeader = () => {
        if (content?.title) {
            return (
                <div className="container">
                    <div className="video-band-title title-wrapper">
                        <div className="title-stroke">
                            <h2>{content.title}</h2>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }

    return (
        <>
            { renderOptionalHeader() }
            <div className={`content-band video-band video-index-${videoIndex}`}>
                <div className="top-tear">
                    <TopTear />
                </div>
                <div className="container">
                    <div className={`video-band-wrapper count-${content.videos.length}`}>
                        { renderVideoThumbs() }
                    </div>
                </div>
                <div className="bottom-tear">
                    <BottomTear />
                </div>
                { showModal &&
                    <Modal
                        closeAction={() => setShowModal(false)}
                        extraClass="video-modal"
                    >
                        <iframe
                            title="ssf-video-player"
                            allowfullscreen=""
                            src={videoSource} />
                    </Modal>
                }
            </div>
        </>
    )
}

export default VideoBand
